const similarProductsConstants = {
	FETCH_GROUPS_REQUEST: 'FETCH_GROUPS_REQUEST',
	FETCH_GROUPS_SUCCESS: 'FETCH_GROUPS_SUCCESS',
	FETCH_GROUPS_FAILURE: 'FETCH_GROUPS_FAILURE',

};

export default similarProductsConstants;
